module.exports = __webpack_public_path__ + "img/close.990cca09.svg";